import { breakpoints, Button, Text } from '@etg/wings';
import { css } from '@eti/styles';
import { useMediaQuery } from 'usehooks-ts';
import { price as priceUtils } from '@eti/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const footerStyles = css`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
`;
const priceStyles = css`
  align-items: flex-start;
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints._768}) {
    align-items: center;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
  }
`;
const TotalFooter = ({
  totalPriceRaw,
  totalPriceLabel,
  saveLabel,
  onSave
}) => {
  const isDesktopView = useMediaQuery(`(min-width: ${breakpoints._768})`);
  return /*#__PURE__*/_jsxs("div", {
    className: footerStyles,
    "data-testid": "pick-and-choose-total-footer",
    children: [/*#__PURE__*/_jsxs("div", {
      className: priceStyles,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: isDesktopView ? '16-bold' : '12',
        children: totalPriceLabel
      }), /*#__PURE__*/_jsx(Text, {
        variant: "24-emphasized",
        children: priceUtils.formatPrice(totalPriceRaw)
      })]
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onSave,
      variant: "primary",
      children: saveLabel
    })]
  });
};
export default TotalFooter;
//# sourceMappingURL=TotalFooter.js.map